import { Injectable } from '@angular/core';
import { GenericHttpService } from './generic-http.service';

@Injectable({
  providedIn: 'root'
})
export class OrganisationService {

  constructor( public httpService: GenericHttpService) { }

 
  getOrganisationDetails() {
    return this.httpService.Get('/organisation/');
  }
  
}
